module.exports = "<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\"\r\n    viewBox=\"0 0 36 36\">\r\n  <circle cx=\"17.93\" cy=\"11.9\" r=\"1.4\"></circle>\r\n  <path d=\"M21,23H19V15H16a1,1,0,0,0,0,2h1v6H15a1,1,0,1,0,0,2h6a1,1,0,0,0,0-2Z\"></path>\r\n  <path d=\"M18,6A12,12,0,1,0,30,18,12,12,0,0,0,18,6Zm0,22A10,10,0,1,1,28,18,10,10,0,0,1,18,28Z\"></path>\r\n</svg>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/kendu/ui/components/kd-alert/icons/info.html
// module id = 289
// module chunks = 0